import { Component, EventEmitter, Input, Output, OnInit, AfterViewInit, OnChanges, SimpleChanges, } from '@angular/core';
import { CatalogCard } from '../../interfaces/catalog-card';
import { PaginatorComponent } from '../paginator/paginator.component';
import { UserAgentService } from '../../services/user-agent.service';
@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss', './catalog.component.en.scss'],
})
export class CatalogComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() resultText?: string;
  @Input() noResultsTitle!: string;
  @Input() noResultsText!: string;
  @Input() noResultsImage!: string;
  @Input() clearAllText!: string;
  @Input() totalSearchResultsCount!: number;
  @Input() pageSize!: number;
  @Input() cards?: CatalogCard[];
  @Input() currentPage!: number;
  @Input() isLoading!: boolean;
  @Output() favoriteToggle = new EventEmitter<number>();

  @Output() pageChange = new EventEmitter<number>();
  @Output() clearAllBtnClick = new EventEmitter<void>();
  
  totalPagesCount: number[] = [];
  private isLoaded: boolean = false;
    rangeSize: number =3;
  
private  isMobile:boolean =false;
  paginatorContainerCssClass=  'pagination';
  constructor( private userAgentService: UserAgentService) {
    this.isMobile = userAgentService.isMobileDevice();
    this.rangeSize= this.isMobile?1:3;
    if(this.isMobile)
    {
      this.paginatorContainerCssClass = 'pagination mobile';
    }
   }

  ngOnChanges(changes: SimpleChanges) {
    if(this.isLoaded) {
      this.setTotalPage();
    }
  }

  ngAfterViewInit(): void {
    this.isLoaded = true;
  }
  logEvent(event: any) {
    //console.log(event);
  }
  ngOnInit(): void { 
    this.setTotalPage();
    this.userAgentService.isMobileDevice();
  }

  private setTotalPage() {
    let totalPages = Math.ceil(this.totalSearchResultsCount / this.pageSize);
    this.totalPagesCount = Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  goToPage(  pageNumber: number): void {
    if (event) event.preventDefault();
    if (
      this.cards != undefined &&
      pageNumber >= 1 &&
      pageNumber <= Math.ceil(this.totalSearchResultsCount / this.pageSize)
    ) {
      this.currentPage = pageNumber;
      this.pageChange.emit(this.currentPage);
    }
  }

  clearAll() {
    this.clearAllBtnClick.emit();
  }

  getHeaderText(): string {
    if(this.resultText!.includes("{0}")) {
      return this.resultText!.replace("{0}", this.totalSearchResultsCount.toString());
    } else {
      return this.resultText + " " + this.totalSearchResultsCount.toString();
    }
  }

  toggleFavorite(id: number) {
    this.favoriteToggle.emit(id);
  }
}
